// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.menu-disabled[data-v-2bf5d24a] {
  opacity: 0.5;
}
.menu-product[data-v-2bf5d24a] {
  margin-top: 25px !important;
  margin-left: 5px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
